module.exports = __webpack_public_path__ + "img/bluecirclesm.cb5403fd.png";